import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgAiIcon7 = (
  {
    title,
    titleId,
    desc,
    descId,
    ...props
  }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    fill="none"
    viewBox="0 0 48 48"
    role="img"
    ref={ref}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <circle cx={24} cy={24} r={24} fill="#000" />
    <g transform="translate(14.85 15.906) scale(1.2)" fill="#fff">
      <path d="M9.4717.1872.2884 7.9225C.1057 8.0764 0 8.3046 0 8.5452v4.1346c0 .4474.358.81.7998.81h4.3871c.1869 0 .3679-.0663.5116-.1873l9.2625-7.802c.1827-.1539.2883-.3821.2883-.6227V.8099c0-.4474-.3581-.81-.7998-.81H9.9831c-.1868 0-.3678.0663-.5114.1872Z" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgAiIcon7);
const Memo = memo(ForwardRef);
export default Memo;
